import { FilterBar, FilterDateRange, FilterTimeRange } from "components/commons";
import React, { useCallback } from "react";
import lang from "translations";

const UnsyncTransactionReportFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  onClear,
  onApply,
}) => {
  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    const { filterState, requestState } = clearFilter();
    onClear(filterState, requestState);
  }, [clearFilter, onClear]);

  return (
    <FilterBar
      className="my-lg"
      filterState={filterState}
      onClear={clearFilterCb}
      onApply={applyFilterCb}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dateRange}
        maxDays={90}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.timeRange}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
    </FilterBar>
  );
};

export default UnsyncTransactionReportFilter;
